import { useStaticQuery, graphql } from "gatsby";
import { BlogPostData } from "../types/BlogPostData";

export function useBlogPosts() {
  const data = useStaticQuery(graphql`
    query {
      allSanityBlogPosts(sort: { fields: postDate, order: DESC }) {
        edges {
          node {
            id
            title
            slug {
              current
            }
            postDate(formatString: "DD MMMM YYYY")
            _rawSummaryText
            _rawBodyText
            tags
          }
        }
      }
    }
  `);

  return data.allSanityBlogPosts.edges.map((x) => x.node as BlogPostData);
}
